<script>

    import { createEventDispatcher, onMount, beforeUpdate } from "svelte";

    const dispatch = createEventDispatcher();

    export let name = '';
    export let id = '';
    export let required = false;
    export let placeholder = '';
    export let maxSize = null;
    export let value = null;
    
    let canvas = document.createElement('canvas');
    let previewImageData = null;
    let imgAspectRatio = 1;
    let imageInput = null;

    const imageSelected = async (evt) => {
        if (evt.target.files && evt.target.files[0]) {
            const imgSrc = URL.createObjectURL(evt.target.files[0]);
            const img = new Image();
            const p = new Promise((resolve, reject) => {
                img.onload = () => {
                    resolve(img);
                }
                img.onerror = () => {
                    reject();
                }
            });
            img.src = imgSrc;
            await p;

            imgAspectRatio = img.width / img.height;

            if (maxSize === null) {
                // Fijamos el tamaño del canvas para que sea igual que la imagen
                // si no se ha fijado un tamaño máximo
                canvas.width = img.width;
                canvas.height = img.height;
            }
            else if (img.width < maxSize && img.height < maxSize) {
                // Si el tamaño de la imagen es menor que el tamaño del canvas
                // entonces fijamos el tamaño del canvas al tamaño de la imagen
                canvas.width = img.width;
                canvas.height = img.width / imgAspectRatio;
            }
            else if (img.width > maxSize && imgAspectRatio > 1) {
                canvas.width = maxSize;
                canvas.height = maxSize / imgAspectRatio;
            }
            else if (img.height > maxSize && imgAspectRatio < 1) {
                canvas.width = maxSize * imgAspectRatio;
                canvas.height = maxSize;
            }
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            previewImageData = canvas.toDataURL("image/png");
        }
        else {
            previewImageData = null;
            return;
        }

        dispatch('change', evt.target);
    }

    onMount(() => {
        // Fijamos el tamaño del canvas si se ha establecido un tamaño máximo
        if (maxSize !== null) {
            canvas.width = maxSize;
            canvas.height = maxSize;
        }
    });

    beforeUpdate(() => {
        if (!value) {
            previewImageData = null;
        }
        else {
            // TODO: Cargar la imagen en el canvas
        }
    })

</script>

<input type="file" name={name} id={id} placeholder={placeholder} accept="image/*" bind:this={imageInput} bind:value={value} capture="environment" required={required} on:change={imageSelected} />
<input type="hidden" name={`${ name }ImageData`} id={`${ id }ImageData`} value={previewImageData} />
{#if previewImageData}
    <img class="image-upload-preview checkered-background" src={previewImageData} alt="Selected file preview" />
{/if}

<style>
    .image-upload-preview {
        width: 300px;
        border: 1px solid #777;
        border-radius: 7px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    
</style>